module.exports = __webpack_public_path__ + "img/PL08935.f787731d.png";